import { render } from "./InfoUser.vue?vue&type=template&id=436c10d5"
import script from "./InfoUser.vue?vue&type=script&lang=js"
export * from "./InfoUser.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__